import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  SvgIcon,
  Collapse,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ReactComponent as AccountBalanceIcon } from '../../../assets/common-assets/account_balance.svg';
import { ReactComponent as FileTextIcon } from '../../../assets/common-assets/file-text.svg';
import { ReactComponent as InvoiceSettingIcon } from '../../../assets/common-assets/settings.svg';
import { ReactComponent as AccountInfoIcon } from '../../../assets/common-assets/user.svg';
import { ReactComponent as ShoppingCart } from '../../../assets/common-assets/sales.svg';
import { ReactComponent as ShoppingBag } from '../../../assets/common-assets/purchase.svg';
import { ReactComponent as FlowConfiguration } from '../../../assets/common-assets/flowConfiguration.svg';

// import { ReactComponent as HeadPhone } from '../../../assets/common-assets/headphones.svg';

// import { ReactComponent as HelpAndSupportIcon }
//  from '../../../assets/common-assets/help-circle.svg';
import { ReactComponent as DollarIcon } from '../../../assets/common-assets/dollar-sign.svg';
import { ReactComponent as BoxIcon } from '../../../assets/common-assets/box.svg';
import { ReactComponent as GridIcon } from '../../../assets/common-assets/Dashboard.svg';
import { ReactComponent as Group } from '../../../assets/superAdmin-Dashboard/users.svg';
import { ReactComponent as SubscriptionPlanIcon } from '../../../assets/common-assets/clipboard.svg';
import { ReactComponent as ActivityHistoryIcon } from '../../../assets/common-assets/activity-history.svg';
import { Root, classes } from './utils';
import { lightPalette } from '../../../theme';
import CustomTooltip from '../../pages/utils/CustomTooltip';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../../services/localStorageUtils';
import ROLES from '../../../constants/roles';

const Sidebar = ({ openSidebar, setOpenSidebar, screenWidth }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const loginRole = getLocalStorageItem('role');
  const userDetail = useSelector((state) => state.user.user);
  const [openSection, setOpenSection] = useState('');

  useEffect(() => {
    const savedSection = localStorage.getItem('openSection');
    if (savedSection && !openSidebar) {
      setOpenSection(savedSection);
    }
  }, []);

  if (openSidebar && openSection) {
    setOpenSection(''); // Reset openSection when sidebar is open
    localStorage.removeItem('openSection'); // Optionally remove saved section
  }
  const strokeColor = (pathname) => {
    // if (location.pathname.includes('invoices/versions')) {
    //   return lightPalette.darkPurple.main;
    // }
    if (
      location.pathname.includes('/log-dashboard') &&
      pathname === 'flow-configuration'
    ) {
      return lightPalette.primary.main;
    }
    if (
      location.pathname.includes(pathname) &&
      !location.pathname.includes('/log-dashboard')
    ) {
      return lightPalette.primary.main;
    }
    if (pathname === 'Purchases') {
      if (
        location.pathname.includes('invoices') ||
        location.pathname.includes('receipts')
      ) {
        return lightPalette.primary.main;
      }
    }
    if (pathname === 'banking') {
      if (
        location.pathname.includes('bank-statements') ||
        location.pathname.includes('creditcardstatements')
      ) {
        return lightPalette.primary.main;
      }
    }
    return lightPalette.lightGrey.main;
  };

  const sideBarMenu = [
    {
      id: 1,
      menu: 'Dashboard',
      navigation: 'admin-dashboard',
      icon: (
        <SvgIcon
          component={GridIcon}
          className={classes.icons}
          stroke={strokeColor('dashboard')}
        />
      ),
    },

    {
      id: 2,
      menu: 'Sales',
      icon: (
        <SvgIcon
          component={ShoppingCart}
          className={classes.icons}
          stroke={strokeColor('sales')}
        />
      ),
      subItems: [
        {
          id: 31,
          menu: 'Sales Invoices',
          navigation: 'sales',
          icon: (
            <SvgIcon
              component={FileTextIcon}
              className={classes.icons}
              stroke={strokeColor('sales')}
            />
          ),
        },
      ],
    },
    {
      id: 3,
      menu: 'Purchases',
      icon: (
        <SvgIcon
          component={ShoppingBag}
          className={classes.icons}
          stroke={strokeColor('Purchases')}
        />
      ),
      subItems: [
        {
          id: 41,
          menu: 'Direct Expenses',
          navigation: 'invoices',
          icon: (
            <SvgIcon
              component={FileTextIcon}
              className={classes.icons}
              stroke={strokeColor('invoices')}
            />
          ),
        },
        {
          id: 42,
          menu: 'Indirect Expenses',
          navigation: 'receipts',
          icon: (
            <SvgIcon
              component={FileTextIcon}
              className={classes.icons}
              stroke={strokeColor('receipts')}
            />
          ),
        },
      ],
    },
    {
      id: 4,
      menu: 'Banking',
      icon: (
        <SvgIcon
          component={AccountBalanceIcon}
          className={classes.icons}
          stroke={strokeColor('banking')}
        />
      ),
      subItems: [
        {
          id: 21,
          menu: 'Bank Statement',
          navigation: 'bank-statements',
          icon: (
            <SvgIcon
              component={FileTextIcon}
              className={classes.icons}
              stroke={strokeColor('bank-statements')}
            />
          ),
        },
        {
          id: 22,
          menu: 'Credit Card Statement',
          navigation: 'creditcardstatements',
          icon: (
            <SvgIcon
              component={FileTextIcon}
              className={classes.icons}
              stroke={strokeColor('creditcardstatements')}
            />
          ),
        },
      ],
    },
    {
      id: 5,
      menu: 'Settings',
      navigation: 'settings',
      icon: (
        <SvgIcon
          component={InvoiceSettingIcon}
          className={classes.icons}
          stroke={strokeColor('setting')}
        />
      ),
    },
    {
      id: 6,
      menu: 'Account Info',
      navigation: 'account-info',
      icon: (
        <SvgIcon
          component={AccountInfoIcon}
          className={classes.icons}
          stroke={strokeColor('account-info')}
        />
      ),
    },
    {
      id: 7,
      menu: 'Flow Configuration',
      navigation: 'flow-configuration',
      icon: (
        <SvgIcon
          component={FlowConfiguration}
          className={classes.icons}
          stroke={strokeColor('flow-configuration')}
        />
      ),
    },
    // {
    //   id: 8,
    //   menu: 'Help',
    //   navigation: 'help',
    //   icon: (
    //     <SvgIcon
    //       component={HelpAndSupportIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('help')}
    //     />),
    // },
    // {
    //   id: 8,
    //   menu: 'Support',
    //   navigation: 'support',
    //   icon: (
    //     <SvgIcon
    //       component={HeadPhone}
    //       className={classes.icons}
    //       stroke={strokeColor('support')}
    //     />),
    // },
  ];

  const superAdminSuperManagerSidebarMenu = [
    {
      id: 1,
      menu: 'Dashboard',
      navigation: 'dashboard',
      icon: (
        <SvgIcon
          component={GridIcon}
          className={classes.icons}
          stroke={strokeColor('dashboard')}
        />
      ),
    },
    {
      id: 2,
      menu: 'Subscriber',
      navigation: 'subscriber',
      icon: (
        <SvgIcon
          component={AccountInfoIcon}
          className={classes.icons}
          stroke={strokeColor('subscriber')}
        />
      ),
    },
    {
      id: 3,
      menu: 'My Team',
      navigation: 'my-team',
      icon: (
        <SvgIcon
          component={Group}
          className={classes.icons}
          stroke={strokeColor('my-team')}
        />
      ),
    },
    {
      id: 4,
      menu: 'Payment History',
      navigation: 'payment',
      icon: (
        <SvgIcon
          component={DollarIcon}
          className={classes.icons}
          stroke={strokeColor('payment')}
        />
      ),
    },
    {
      id: 5,
      menu: 'Scanning History',
      navigation: 'scan-history',
      icon: (
        <SvgIcon
          component={BoxIcon}
          className={classes.icons}
          stroke={strokeColor('scan-history')}
        />
      ),
    },
    // {
    //   id: 6,
    //   menu: 'Accuracy Details',
    //   navigation: 'accuracy-details',
    //   icon: (
    //     <SvgIcon
    //       component={AccuracyDetailsIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('accuracy-details')}
    //     />),
    // },
    {
      id: 6,
      menu: 'Activity History',
      navigation: 'activity-history',
      icon: (
        <SvgIcon
          component={ActivityHistoryIcon}
          className={classes.icons}
          stroke={strokeColor('activity-history')}
        />
      ),
    },
    {
      id: 7,
      menu: 'My Account',
      navigation: 'my-account',
      icon: (
        <SvgIcon
          component={BoxIcon}
          className={classes.icons}
          stroke={strokeColor('my-account')}
        />
      ),
    },
    {
      id: 8,
      menu: 'Subscription Plan',
      navigation: 'subscription-plan',
      icon: (
        <SvgIcon
          component={SubscriptionPlanIcon}
          className={classes.icons}
          stroke={strokeColor('subscription-plan')}
        />
      ),
    },
    // {
    //   id: 9,
    //   menu: 'Help',
    //   navigation: 'SA-help',
    //   icon: (
    //     <SvgIcon
    //       component={HelpAndSupportIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('SA-help')}
    //     />),
    // },
    // {
    //   id: 10,
    //   menu: 'Support',
    //   navigation: 'SA-support',
    //   icon: (
    //     <SvgIcon
    //       component={HeadPhone}
    //       className={classes.icons}
    //       stroke={strokeColor('SA-support')}
    //     />),
    // },
  ];

  const salesAdminSalesSidebarMenu = [
    {
      id: 1,
      menu: 'Dashboard',
      navigation: 'sales-admin-dashboard',
      icon: (
        <SvgIcon
          component={GridIcon}
          className={classes.icons}
          stroke={strokeColor('sales-admin-dashboard')}
        />
      ),
    },
    {
      id: 2,
      menu: 'Subscriber',
      navigation: 'subscriber',
      icon: (
        <SvgIcon
          component={AccountInfoIcon}
          className={classes.icons}
          stroke={strokeColor('subscriber')}
        />
      ),
    },
    {
      id: 3,
      menu: 'My Team',
      navigation: 'my-team',
      icon: (
        <SvgIcon
          component={Group}
          className={classes.icons}
          stroke={strokeColor('my-team')}
        />
      ),
    },
    {
      id: 4,
      menu: 'Payment History',
      navigation: 'payment',
      icon: (
        <SvgIcon
          component={DollarIcon}
          className={classes.icons}
          stroke={strokeColor('payment')}
        />
      ),
    },
    {
      id: 5,
      menu: 'Scanning History',
      navigation: 'scan-history',
      icon: (
        <SvgIcon
          component={BoxIcon}
          className={classes.icons}
          stroke={strokeColor('scan-history')}
        />
      ),
    },
    // {
    //   id: 6,
    //   menu: 'Accuracy Details',
    //   navigation: 'accuracy-details',
    //   icon: (
    //     <SvgIcon
    //       component={AccuracyDetailsIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('accuracy-details')}
    //     />),
    // },
    {
      id: 6,
      menu: 'Activity History',
      navigation: 'activity-history',
      icon: (
        <SvgIcon
          component={ActivityHistoryIcon}
          className={classes.icons}
          stroke={strokeColor('activity-history')}
        />
      ),
    },
    {
      id: 7,
      menu: 'My Account',
      navigation: 'my-account',
      icon: (
        <SvgIcon
          component={BoxIcon}
          className={classes.icons}
          stroke={strokeColor('my-account')}
        />
      ),
    },
    // {
    //   id: 9,
    //   menu: 'Subscription Plan',
    //   navigation: 'subscription-plan',
    //   icon: (
    //     <SvgIcon
    //       component={SubscriptionPlanIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('subscription-plan')}
    //     />),
    // },
    // {
    //   id: 8,
    //   menu: 'Help',
    //   navigation: 'SA-help',
    //   icon: (
    //     <SvgIcon
    //       component={HelpAndSupportIcon}
    //       className={classes.icons}
    //       stroke={strokeColor('SA-help')}
    //     />),
    // },
    // {
    //   id: 9,
    //   menu: 'Support',
    //   navigation: 'SA-support',
    //   icon: (
    //     <SvgIcon
    //       component={HeadPhone}
    //       className={classes.icons}
    //       stroke={strokeColor('SA-support')}
    //     />),
    // },
  ];

  const handleMenuToggle = (menu) => {
    const newOpenSection = openSection === menu ? '' : menu;
    setOpenSection(newOpenSection);
    setLocalStorageItem('openSection', newOpenSection);
  };

  const handleItemClick = (item) => {
    let found = false;
    sideBarMenu?.forEach((element) => {
      if (found) return;
      if (element.navigation === 'account-info' && item.id === element.id) {
        setOpenSidebar(true);
        navigate(`/${element.navigation}?tab=myAccount`);
        setLocalStorageItem('openSection', '');
        setOpenSection('');
        found = true;
      } else if (!element.subItems && item.id === element.id) {
        navigate(`/${element.navigation}`);
        setOpenSection('');
        setLocalStorageItem('openSection', '');
        setOpenSidebar(true);
        found = true;
      } else if (element.subItems) {
        element.subItems.forEach((subElement) => {
          if (found) return;
          if (item.id === subElement.id) {
            navigate(`/${subElement.navigation}`);
            setOpenSection('');
            setLocalStorageItem('openSection', '');
            setOpenSidebar(true);
            found = true;
          }
        });
      }
    });
  };

  const handleSuperAdminSuperManagerItemClick = (item) => {
    superAdminSuperManagerSidebarMenu?.map((element) => {
      if (item.id === element.id) {
        if (element.navigation === 'accuracy-details') {
          navigate("/accuracy-details/'all-documents'");
          setOpenSidebar(true);
        } else {
          navigate(`/${element.navigation}`);
          setOpenSidebar(true);
        }
      }
      return element;
    });
  };

  const handleSalesAdminSalesItemClick = (item) => {
    salesAdminSalesSidebarMenu?.map((element) => {
      if (item.id === element.id) {
        if (element.navigation === 'accuracy-details') {
          navigate("/accuracy-details/'all-documents'");
          setOpenSidebar(true);
        } else {
          navigate(`/${element.navigation}`);
          setOpenSidebar(true);
        }
      }
      return element;
    });
  };

  const sidebarWidth =
    screenWidth < 600 ? (openSidebar ? 0 : 80) : openSidebar ? 80 : 250;

  const sidebarMenuBackgroundColor = (element) => {
    // if (location.pathname.includes('invoices/versions')) {
    //   return lightPalette.lightGrey.main;
    // }
    if (location.pathname.includes('invoices/versions')) {
      return '0';
    }
    if (
      location.pathname.includes('/log-dashboard') &&
      element.navigation === 'flow-configuration'
    ) {
      return lightPalette.primary.lighter;
    }
    if (
      location.pathname.includes(element.navigation) ||
      (element.subItems &&
        element.subItems.some((subItem) =>
          location.pathname.includes(subItem.navigation),
        ))
    ) {
      return lightPalette.primary.lighter;
    }
    return '0';
  };

  const openSidebarMenuBackgroundColor = (element) => {
    if (
      location.pathname.includes('/log-dashboard') &&
      element.navigation === 'flow-configuration'
    ) {
      return lightPalette.primary.main;
    }
    if (
      location.pathname.includes(element.navigation) ||
      (element.subItems &&
        element.subItems.some((subItem) =>
          location.pathname.includes(subItem.navigation),
        ))
    ) {
      return lightPalette.primary.main;
    }
    return lightPalette.lightGrey.main;
  };

  let filteredSideBarMenu = sideBarMenu;

  if (loginRole !== ROLES.ADMIN) {
    if (loginRole === ROLES.MANAGER) {
      if (userDetail.is_fc !== true) {
        filteredSideBarMenu = sideBarMenu.filter(
          (_, index) => index !== 0 && index !== 5 && index !== 6,
        );
      } else {
        filteredSideBarMenu = sideBarMenu.filter(
          (_, index) => index !== 0 && index !== 5,
        );
      }
    } else if (loginRole === ROLES.MEMBER) {
      filteredSideBarMenu = sideBarMenu.filter(
        (_, index) => index !== 0 && index !== 5 && index !== 6,
      );
    }
  }

  let filteredSalesSideBarMenu = salesAdminSalesSidebarMenu;

  if (loginRole === ROLES.SALES) {
    filteredSalesSideBarMenu = salesAdminSalesSidebarMenu.filter(
      (_, index) => index !== 0 && index !== 2,
    );
  }

  return (
    <Root>
      <Box
        className={classes.sidebarMainBox}
        width={
          screenWidth < 600 ? (openSidebar ? 0 : 80) : openSidebar ? 80 : 250
        }
        position={screenWidth < 600 ? 'absolute' : 'relative'}
      >
        {loginRole === ROLES.ADMIN ||
        loginRole === ROLES.MANAGER ||
        loginRole === ROLES.MEMBER ? (
          <Box className={classes.listMainBox} width={sidebarWidth}>
            <List>
              {filteredSideBarMenu.map((element) => (
                <>
                  <ListItem
                    key={element.id}
                    className={classes.listItems}
                    sx={{
                      backgroundColor: sidebarMenuBackgroundColor(element),
                      '&:hover': {
                        backgroundColor: lightPalette.primary.lighter,
                      },
                    }}
                    onClick={() => {
                      // Set openSidebar to false first
                      if (element.subItems && openSidebar) {
                        setOpenSidebar(false);
                        handleMenuToggle(element.menu);
                      } else if (element.subItems) {
                        handleMenuToggle(element.menu);
                      } else {
                        handleItemClick(element, false);
                      }
                    }}
                  >
                    <CustomTooltip title={openSidebar ? element.menu : null}>
                      <ListItemIcon>{element.icon}</ListItemIcon>
                    </CustomTooltip>
                    {openSidebar ? null : (
                      <ListItemText
                        primary={`${element.menu}`}
                        className={classes.listItemTexts}
                        sx={{
                          color: openSidebarMenuBackgroundColor(element),
                          display:
                            screenWidth < 600
                              ? !openSidebar
                                ? 'none'
                                : 'flex'
                              : 'flex',
                        }}
                      />
                    )}
                    {element.subItems && (
                      <ExpandMoreIcon
                        className={`${classes.listItemExpandIcon} ${openSection === element.menu ? classes.listItemExpandIconOpen : classes.listItemExpandIconClose}`}
                        sx={{
                          color: openSidebarMenuBackgroundColor(element),
                        }}
                      />
                    )}
                  </ListItem>
                  {element.subItems && (
                    <Collapse
                      in={openSection === element.menu}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding>
                        {element?.subItems?.map((subItem) => (
                          <ListItem
                            key={subItem.id}
                            className={classes.listSubItems}
                            sx={{
                              // backgroundColor: sidebarMenuBackgroundColor(subItem),
                              '&:hover': {
                                backgroundColor: lightPalette.primary.lighter,
                              },
                            }}
                            onClick={() => handleItemClick(subItem, false)}
                          >
                            {/* <ListItemIcon>
                              {element.icon}
                            </ListItemIcon> */}
                            {openSidebar ? null : (
                              <ListItemText
                                primary={subItem.menu}
                                className={classes.listSubItemTexts}
                                sx={{
                                  color:
                                    openSidebarMenuBackgroundColor(subItem),
                                  display:
                                    screenWidth < 600
                                      ? !openSidebar
                                        ? 'none'
                                        : 'flex'
                                      : 'flex',
                                }}
                              />
                            )}
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </>
              ))}
            </List>
          </Box>
        ) : null}
        {(loginRole === ROLES.SUPER_ADMIN ||
          loginRole === ROLES.SUPER_MANAGER) && (
          <Box className={classes.listMainBox} width={sidebarWidth}>
            <List>
              {superAdminSuperManagerSidebarMenu.map((item) => (
                <ListItem
                  key={item.id}
                  className={classes.listItems}
                  sx={{
                    backgroundColor: location.pathname.includes(item.navigation)
                      ? lightPalette.primary.lighter
                      : '0',
                    '&:hover': {
                      backgroundColor: lightPalette.primary.lighter,
                    },
                  }}
                  onClick={() => handleSuperAdminSuperManagerItemClick(item)}
                >
                  <CustomTooltip title={openSidebar ? item.menu : null}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </CustomTooltip>
                  {openSidebar ? null : (
                    <ListItemText
                      primary={item.menu}
                      className={classes.listItemTexts}
                      sx={{
                        color: location.pathname.includes(item.navigation)
                          ? lightPalette.primary.main
                          : lightPalette.lightGrey.main,
                        display:
                          screenWidth < 600
                            ? !openSidebar
                              ? 'none'
                              : 'flex'
                            : 'flex',
                      }}
                    />
                  )}
                </ListItem>
              ))}
            </List>
          </Box>
        )}
        {(loginRole === ROLES.SALES_ADMIN || loginRole === ROLES.SALES) && (
          <Box className={classes.listMainBox} width={sidebarWidth}>
            <List>
              {filteredSalesSideBarMenu.map((item) => (
                <ListItem
                  key={item.id}
                  className={classes.listItems}
                  sx={{
                    backgroundColor: location.pathname.includes(item.navigation)
                      ? lightPalette.primary.lighter
                      : '0',
                    '&:hover': {
                      backgroundColor: lightPalette.primary.lighter,
                    },
                  }}
                  onClick={() => handleSalesAdminSalesItemClick(item)}
                >
                  <CustomTooltip title={openSidebar ? item.menu : null}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </CustomTooltip>
                  {openSidebar ? null : (
                    <ListItemText
                      primary={item.menu}
                      className={classes.listItemTexts}
                      sx={{
                        color: location.pathname.includes(item.navigation)
                          ? lightPalette.primary.main
                          : lightPalette.lightGrey.main,
                        display:
                          screenWidth < 600
                            ? !openSidebar
                              ? 'none'
                              : 'flex'
                            : 'flex',
                      }}
                    />
                  )}
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </Box>
    </Root>
  );
};

Sidebar.propTypes = {
  openSidebar: PropTypes.bool.isRequired,
  setOpenSidebar: PropTypes.func.isRequired,
  screenWidth: PropTypes.number.isRequired,
};

export default Sidebar;
